<template>
  <date-filter-value :date="date"
                     :format="format"
  >
    <template #icon>
      <date-from-icon class="mb-1"/>
    </template>
  </date-filter-value>
</template>

<script>
import DateFromIcon from '@/assets/images/icons/DateFromIcon'
import DateFilterValue from './DateFilterValue'
import datetimeUtils from '@/utils/datetime.utils'

export default {
  name: 'DateFromFilterValue',

  components: { DateFilterValue, DateFromIcon },

  props: {
    date: {
      type: String,
      required: true
    }
  },

  computed: {
    format() {
      return datetimeUtils.toMoment(this.date).format('HH:mm') === '00:00' ?
        'D MMM, YY' :
        'D MMM, YY [at] HH:mm'
    }
  }
}
</script>
